import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import {navigator} from 'lit-element-router';
import store from '../../store';
import next from '../../../icons/next';
import loading from '../../../icons/loading';
import reset from '../../../icons/reset';
import info from '../../../icons/info';

import {setSection} from '../../slices/statusSlice';
import {routeUrl} from '../../util/routeUrl';
import {selectIomo3DReady} from '../iomoSelectors';

@customElement('iomo-start')
export class IomoStart extends connect(store)(navigator(LitElement)) {

	static styles = [
		css`
			:host {
				width: var(--assistant-widget-width);
			}

			.title {
				display: flex;
				align-items: center;
				font: var(--font-widget-big-title);
				color: var(--color-widget-text);
				line-height: 1.4;
				margin-bottom: 40px;
			}

			.description {
				font: var(--font-widget-label);
				color: var(--color-widget-text);
				line-height: 1.4;
				margin-bottom: 40px;
			}

			button, .button {
				display: flex;
				gap: var(--small-padding);
				align-items: center;
				justify-content: center;
				flex-direction: row;

				font-family: var(--font-family-light);
				font-size: var(--font-size-widget);
				color: var(--color-widget-text);
				height: var(--nav-button-height);
				width: 100%;
				letter-spacing: 1px;
				background-color: var(--color-widget-background);
				border: none;
				cursor: pointer;
				line-height: 0;
				transition: background-color 0.4s ease-out, color 0.4s ease-out;
				text-decoration: none;
				margin-bottom: var(--small-padding);
			}

			button:hover, .button:hover {
				background-color: var(--color-widget-background-hover);
			}
			button[disabled] {
				pointer-events: none;
				color: var(--color-widget-text-disabled);
			}

			.icon {
				display: inline-block;
				max-width: 20px;
				color: var(--color-widget-text);
			}
        `];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.isInitialized = state.status.initialized && selectIomo3DReady(state);
	}
	onClick() {
		store.dispatch(
			setSection({currentSection: 'iomoMounting'})
		);
	}
	onReset() {
		this.navigate(routeUrl({media: 'sections', key: 'new'}));
		window.location.reload();
	}
	render() {
		const s = store.getState();

		return html`
			<div>
				<div class="title">Iomo</div>
				<div class="description">
					${msg('The most versatile luminaire we ever created.')}
				</div>
				<button @click=${this.onClick} .disabled=${!this.isInitialized}>
					${when(this.isInitialized,
						() => html`${msg('Start Configuration')}`,
						() => html`${msg('Loading')}...`
					)}
					<span class="icon">${this.isInitialized ? next : loading}</span>
				</button>
				<button @click=${this.onReset}>
					${msg('Reset Configuration')}
					<span class="icon">${reset}</span>
				</button>
				<a class="button" href="https://www.selux.com/int/${this.lang}/landing/iomo-consultation" target="_blank">
					${msg('Personal Consultation')}
					<span class="icon">${info}</span>
				</a>
			</div>

		`;
	}
}
